import React from 'react';

const LogoutIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20">
      <path d="m13.229 14.521-1.396-1.375L14 11H7.438V9h6.5l-2.105-2.104 1.396-1.375 4.5 4.5ZM2.271 17.667V2.333h7.75v1.979H4.25v11.376h5.771v1.979Z" />
    </svg>
  );
};

export default LogoutIcon;
